import { Alert } from '@mui/material';
import { FormDialog, FormTextField } from '../../../design-system';

export type StaffingCorrectionDialogProps = {
  open: boolean;
  busy: boolean;
  error: string;
  effectiveDate: string;
  reason: string;
  onClose: () => void;
  onSubmit: () => void;
  onEffectiveDateChange: (value: string) => void;
  onReasonChange: (value: string) => void;
};

export function StaffingCorrectionDialog({
  open,
  busy,
  error,
  effectiveDate,
  reason,
  onClose,
  onSubmit,
  onEffectiveDateChange,
  onReasonChange,
}: StaffingCorrectionDialogProps) {
  return <FormDialog
    open={open}
    onClose={onClose}
    onSubmit={onSubmit}
    title="완료 발령 시행일 정정"
    cancelLabel="취소"
    submitLabel="정정 승인 요청"
    busy={busy}
    busyLabel="요청 중…"
  >
    {error && <Alert severity="error">{error}</Alert>}
    <Alert severity="warning">기존 원장은 삭제하지 않고 정정 발령을 승인 흐름으로 추가합니다.</Alert>
    <FormTextField required type="date" label="정정 시행일" value={effectiveDate} onChange={(event) => onEffectiveDateChange(event.target.value)} />
    <FormTextField required label="정정 사유" value={reason} multiline minRows={3} onChange={(event) => onReasonChange(event.target.value)} />
  </FormDialog>;
}
